<template>
  <div class="cart__header" v-if="$store.getters['auth/isRole']('ROLE_TECHNICIAN') == true">
    <backlink/>
    <div class="cart__header-title-container">
      <img src="/static/img/pictos/produit-favoris.svg" class="">
      <span>Mes favoris</span>
    </div>
  </div>
</template>

<script>


export default {
  name: "FavoritesHeader",
  data() {
    return {

    }
  },
  components: {

  },
  computed: {

  },
  mounted() {

  }
};
</script>

<style lang="scss" scoped>
  @import "~@/assets/scss/_colors.scss";

  .cart__header{ background-color: $vertjaune; padding: 65px 20px 0 20px; width: 100%;
    .backlink{ margin-bottom: 5px; }
    .cart__header-title-container{ display: flex; align-items: flex-end; }
    img{ width: 100px; margin-left: 35px; opacity: 0.4; }
    span{ color: white; font-family: 'ClanFFBlack'; font-size: 25px; margin-top: 25px; text-transform: uppercase; flex: 1; text-align: right;}
  }

</style>



// WEBPACK FOOTER //
// src/components/Product/FavoritesHeader.vue